import PropTypes from "prop-types";
import { useCallback } from "react";
import { useSelector } from "react-redux";

import BasicModal from "../../../components/modals/BasicModal";

import { useLoanFilesHook } from "../../../hooks/useLoanFilesHook";

import RffBooleanCheckbox from "../../../components/finalForm/inputs/RffBooleanCheckbox";
import RffFileUploadField from "../../../components/finalForm/inputs/RffFileUploadField";
import RffSelectToggleField from "../../../components/finalForm/inputs/RffSelectToggleField";
import RffForm from "../../../components/finalForm/RffForm";
import RffGroup from "../../../components/finalForm/shared/RffGroup";

const LoanSizerUploader = ({ show, onClose }) => {
  const { loading, uploadLoanSizer } = useLoanFilesHook();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const onModalClose = useCallback(() => {
    onClose(false);
  }, [onClose]);

  const onFormSubmit = useCallback(
    (data) => {
      console.log("Submit", data);
      uploadLoanSizer({
        payload: data,
        loanId: loanDrilldown?._id,
        onSuccessFn: (d) => {
          console.log("Success", d);
          onModalClose();
        },
      });
    },
    [uploadLoanSizer, loanDrilldown?._id, onModalClose]
  );

  return (
    <BasicModal
      allowFullScreen
      title={"Upload Loan Sizer"}
      show={show}
      onClose={onModalClose}
      maxWidth={"sm"}
      bodySx={{
        p: 3,
        ".MuiSelect-select": {
          fontSize: "12px",
        },
      }}
    >
      <RffForm
        footerStartContent={
          <RffBooleanCheckbox
            label={"Extract Sizer Data"}
            name="extractSizerData"
          />
        }
        hideBottomValidationErrors
        onSubmit={onFormSubmit}
        loading={loading}
        initialValues={{}}
      >
        <FormQuestions />
      </RffForm>
    </BasicModal>
  );
};

const FormQuestions = () => {
  return (
    <RffGroup>
      <RffSelectToggleField
        name="sizerType"
        label={"Sizer Type"}
        required
        options={["EV GUC", "EV RTL", "EV DSCR", "Other"]}
      />
      <RffSelectToggleField
        required
        name="sizerStage"
        label={"Sizer Stage"}
        options={[
          "Intake Pricing",
          "Request Lock Pricing",
          "Update Lock Pricing",
          "Final Pricing for Closing",
        ]}
      />

      <RffFileUploadField
        required
        label="Upload Loan Sizer"
        docGroup={"Terms & Sizer"}
        docType={"Sizer"}
      />
    </RffGroup>
  );
};

LoanSizerUploader.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LoanSizerUploader;
